import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const IconMenu = createSvgIcon(
  <svg width="252" height="177" viewBox="0 0 252 177" fill="none">
    <g fill="currentColor">
      <rect x="0.957031" y="0.86084" width="250.94" height="25.094" />
      <rect x="0.957031" y="76.1426" width="250.94" height="25.094" />
      <rect x="113.881" y="151.425" width="138.017" height="25.094" />
    </g>
  </svg>,
  'IconMenu'
);
